import React from 'react'
import MediaQuery from 'react-responsive'
import { primary } from '../../assets/colors'
import logo from '../../assets/img/logo.svg'
import { Header, Nav, IconsBox, MobileNavigation, IframeRolex } from '@pga/pga-component-library'
import { publicOptions, authenticatedOptions, mobileOptions, dropdownLinks } from './options'
import { withAuthProvider } from '../../lib/auth'
import AuthHeader from './AuthHeader'
import { EditLink, NavigationBox, LinkStyled } from './Header.styles'

const HeaderComponent = ({ isLoggedIn, me, authReady }) => (
  <Header
    logo={logo}
    logoLink='/'
    bgColor={primary}
  >
    <MediaQuery minWidth={992}>
      <NavigationBox>
        <Nav
          options={
            isLoggedIn
              ? [...publicOptions, ...authenticatedOptions]
              : publicOptions
          }
          comp={LinkStyled}
        />
        <div className='d-flex align-items-center'>
          <IframeRolex />
          <IconsBox />
        </div>
        <AuthHeader isLoggedIn={isLoggedIn} me={me} options={dropdownLinks} />
      </NavigationBox>
    </MediaQuery>
    <MediaQuery maxWidth={991}>
      <MobileNavigation
        linkComponent={() => <EditLink />}
        options={
          isLoggedIn
            ? [...publicOptions, ...authenticatedOptions, ...mobileOptions]
            : [...publicOptions, ...mobileOptions]
        }
        me={me}
        comp={() => <EditLink />}
        b={-7} l={11} vertical
      />
    </MediaQuery>
  </Header>
)

export default withAuthProvider(HeaderComponent)
